import { render } from "./TrackPreview.vue?vue&type=template&id=2b1aea72&lang=html"
import script from "./TrackPreview.vue?vue&type=script&lang=js"
export * from "./TrackPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__